import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Share2, Webhook, Calendar, Rss } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

export const AutomationSettings = () => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [webhookUrl, setWebhookUrl] = useState("");

  const handleZapierWebhook = async () => {
    if (!webhookUrl) {
      toast({
        title: "Error",
        description: "Please enter your Zapier webhook URL",
        variant: "destructive",
      });
      return;
    }

    setIsLoading(true);
    try {
      await fetch(webhookUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        mode: "no-cors",
        body: JSON.stringify({
          timestamp: new Date().toISOString(),
          triggered_from: window.location.origin,
        }),
      });

      toast({
        title: "Webhook Tested",
        description: "The test request was sent to Zapier successfully.",
      });
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to test the Zapier webhook. Please check the URL.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Automation Settings</CardTitle>
        <CardDescription>Configure automation and integration settings</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-4">
          <div className="grid gap-2">
            <Label>Zapier Webhook URL</Label>
            <Input
              placeholder="Enter your Zapier webhook URL"
              value={webhookUrl}
              onChange={(e) => setWebhookUrl(e.target.value)}
            />
          </div>
          <Button
            onClick={handleZapierWebhook}
            disabled={isLoading || !webhookUrl}
          >
            <Webhook className="mr-2 h-4 w-4" />
            Test Webhook
          </Button>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="space-y-1">
              <Label>Email Automation</Label>
              <p className="text-sm text-muted-foreground">
                Automated email notifications
              </p>
            </div>
            <Switch defaultChecked />
          </div>

          <div className="flex items-center justify-between">
            <div className="space-y-1">
              <Label>Social Media Integration</Label>
              <p className="text-sm text-muted-foreground">
                Automatic social media posting
              </p>
            </div>
            <Switch />
          </div>

          <div className="flex items-center justify-between">
            <div className="space-y-1">
              <Label>Calendar Integration</Label>
              <p className="text-sm text-muted-foreground">
                Sync with Google Calendar
              </p>
            </div>
            <Switch />
          </div>

          <div className="flex items-center justify-between">
            <div className="space-y-1">
              <Label>RSS Feed Integration</Label>
              <p className="text-sm text-muted-foreground">
                Automatic content syndication
              </p>
            </div>
            <Switch />
          </div>
        </div>

        <Button onClick={() => {}} disabled={isLoading}>
          <Share2 className="mr-2 h-4 w-4" />
          Save Automation Settings
        </Button>
      </CardContent>
    </Card>
  );
};